import { useEffect, useRef, useState } from 'react';

const STORAGE_KEY = 'sports-hq-match-sort';
const valid = value => value === 'time' || value === 'league';
const localChoice = () => {
  try { return window.localStorage.getItem(STORAGE_KEY); } catch { return null; }
};
const saveLocal = value => {
  try { window.localStorage.setItem(STORAGE_KEY, value); return true; } catch { return false; }
};
const request = async (method = 'GET', sort_order) => {
  const response = await fetch('/sportsim/api/auth/match-sort', {
    method, credentials: 'same-origin', cache: 'no-store',
    ...(method === 'PUT' ? { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ sort_order }) } : {}),
  });
  if (!response.ok) throw new Error(String(response.status));
  return response.json();
};

export default function useMatchSort() {
  const [savedOrder, setSavedOrder] = useState(() => valid(localChoice()) ? localChoice() : 'league');
  const [ready, setReady] = useState(false);
  const [notice, setNotice] = useState('');
  const authenticated = useRef(null);
  const queue = useRef(Promise.resolve());
  const version = useRef(0);
  useEffect(() => {
    let active = true;
    request().then(data => {
      if (!active) return;
      authenticated.current = data.authenticated;
      if (data.authenticated && valid(data.sort_order)) setSavedOrder(data.sort_order);
      setReady(true);
    }).catch(() => { if (active) setReady(true); });
    return () => { active = false; };
  }, []);

  const saveOrder = value => {
    setSavedOrder(value);
    setNotice('');
    if (authenticated.current === false) {
      if (!saveLocal(value)) setNotice('Sorteringen kunde inte sparas på den här enheten.');
      return;
    }
    const current = ++version.current;
    // Serialize writes so a slower earlier selection cannot overwrite the latest choice.
    queue.current = queue.current.catch(() => {}).then(() => request('PUT', value));
    queue.current.catch(error => {
      if (current !== version.current) return;
      if (error.message === '401') {
        authenticated.current = false;
        if (!saveLocal(value)) setNotice('Sorteringen kunde inte sparas på den här enheten.');
      } else {
        setNotice('Sorteringen kunde inte sparas till kontot. Välj igen för att försöka på nytt.');
      }
    });
  };
  return { savedOrder, saveOrder, ready, notice };
}
